import cmp from './VendorList'

export default cmp
